module.exports = __webpack_public_path__ + "img/sld_abt_check_t1_b1_dark.13f7a6ec.svg";